// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"66":"781ec135","453":"9bc2487e"}[chunkId] + ".chunk.js";
};